function Tab() {
    throw new Error('The "Tab" component is not meant to be rendered! It\'s an abstract component that is only valid as a direct Child of the "TabContainer" Component.');
}

export default Tab;
